module.exports = "/assets/sample1-c3e788d9dd08247bea8563758e5a20a2.jpg";